require("./_config");

window.$ = window.jQuery = require("jquery");

const mobileMenu = require("./_mobilemenu");
const matchheight = require("./_matchheight");
const actionbanner = require("./_actionbanner");
const languagepicker = require("./_languagepicker");
const gallery = require("./_gallery");

$(() => {
  mobileMenu.init();
  matchheight.init();
  actionbanner.init();
  languagepicker.init();
  gallery.init();
});
